declare var apiSettings: any;
export let CONFIG = {

  baseUrls: {
    api: apiSettings.apiUrl,
  }
};
